// lowercase for reason so we take into account all caps and non all caps ways
export enum VendorType {
  TRADE_PARTNER_AFFILIATE = 'trade partner affiliate',
  SUBCONTRACTOR_CURRENT = 'subcontractor (current)',
  BL_SUBCONTRACTOR_CURRENT = 'bl_subcontractor (current)',
  BLACK_LISTED_VENDOR = 'black listed vendor',
  CONSTRUCTION_LENDERS = 'construction lenders',
  GOVERNMENT = 'government',
  MATERIAL_SUPPLIER_ACTIVE = 'material supplier (active)',
  MATERIAL_SUPPLIER_INACTIVE = 'material supplier (inactive)',
  MISC = 'misc',
  MORTGAGE_LENDER = 'mortgage lender',
  SUB_INACTIVE_UNAPPROVED = 'sub (inactive/unapproved)'
}

// TODO might have to update these values to be lower case and then do a .toLowerCase() when doing a comparison
export type VendorTypeValue =
  | 'Trade Partner Affiliate'
  | 'Subcontractor (Current)'
  | 'Bl_Subcontractor (Current)'
  | 'Black Listed Vendor'
  | 'Construction Lenders'
  | 'Government'
  | 'Material Supplier (Active)'
  | 'Material Supplier (Inactive)'
  | 'Misc'
  | 'Mortgage Lender'
  | 'Sub (Inactive/Unapproved)';
